'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var Clipboard = _interopDefault(require('clipboard'));

var version = "0.0.0";

var url = getUrl();

function getUrl() {
  return window.location.href;
}

function getRedirectUri() {
  return url + '#close_window';
}

function getEmbedCode() {
  return '<iframe src=\'' + url + '\' width=\'560\' height=\'315\' frameborder=\'0\' allowfullscreen></iframe>';
}

var defaults = {
  title: 'Video',
  url: url,
  embedCode: getEmbedCode(),
  redirectUri: getRedirectUri()
};

var asyncGenerator = function () {
  function AwaitValue(value) {
    this.value = value;
  }

  function AsyncGenerator(gen) {
    var front, back;

    function send(key, arg) {
      return new Promise(function (resolve, reject) {
        var request = {
          key: key,
          arg: arg,
          resolve: resolve,
          reject: reject,
          next: null
        };

        if (back) {
          back = back.next = request;
        } else {
          front = back = request;
          resume(key, arg);
        }
      });
    }

    function resume(key, arg) {
      try {
        var result = gen[key](arg);
        var value = result.value;

        if (value instanceof AwaitValue) {
          Promise.resolve(value.value).then(function (arg) {
            resume("next", arg);
          }, function (arg) {
            resume("throw", arg);
          });
        } else {
          settle(result.done ? "return" : "normal", result.value);
        }
      } catch (err) {
        settle("throw", err);
      }
    }

    function settle(type, value) {
      switch (type) {
        case "return":
          front.resolve({
            value: value,
            done: true
          });
          break;

        case "throw":
          front.reject(value);
          break;

        default:
          front.resolve({
            value: value,
            done: false
          });
          break;
      }

      front = front.next;

      if (front) {
        resume(front.key, front.arg);
      } else {
        back = null;
      }
    }

    this._invoke = send;

    if (typeof gen.return !== "function") {
      this.return = undefined;
    }
  }

  if (typeof Symbol === "function" && Symbol.asyncIterator) {
    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
      return this;
    };
  }

  AsyncGenerator.prototype.next = function (arg) {
    return this._invoke("next", arg);
  };

  AsyncGenerator.prototype.throw = function (arg) {
    return this._invoke("throw", arg);
  };

  AsyncGenerator.prototype.return = function (arg) {
    return this._invoke("return", arg);
  };

  return {
    wrap: function (fn) {
      return function () {
        return new AsyncGenerator(fn.apply(this, arguments));
      };
    },
    await: function (value) {
      return new AwaitValue(value);
    }
  };
}();





var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};











var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};











var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var Button = videojs.getComponent('Button');

/**
 * export button.
 */

var ExportButton = function (_Button) {
  inherits(ExportButton, _Button);

  function ExportButton(player, options) {
    classCallCheck(this, ExportButton);

    var _this = possibleConstructorReturn(this, _Button.call(this, player, options));

    _this.addClass('vjs-menu-button');
    _this.addClass('vjs-export-control');
    _this.addClass('vjs-icon-export');
    _this.controlText(player.localize('Share'));
    return _this;
  }

  ExportButton.prototype.handleClick = function handleClick() {
    this.player().getChild('ExportOverlay').open();
  };

  return ExportButton;
}(Button);

/**
 * @return {boolean}
 */
var embedLink = void 0;
var defaultVarEmbedLink = {
  start: 0,
  autoplay: 0,
  color: "FFFFFF"
};

function getEmbedLink() {
  console.log(defaultVarEmbedLink.start);
  var embed = embedLink;
  var final_embed = embed.replace("[color]", defaultVarEmbedLink.color);
  final_embed = final_embed.replace("[start]", defaultVarEmbedLink.start);
  final_embed = final_embed.replace("[autoplay]", defaultVarEmbedLink.autoplay);
  final_embed = final_embed.replace("[vod_id]", "1");
  return final_embed;
}

function generateEmbedLink() {
  var link = getEmbedLink();
  if (document.getElementById('ifram_int')) document.getElementById('ifram_int').value = '<iframe width="560" height="315" src="' + link + '" frameborder="0"  allowfullscreen></iframe>';
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.MaxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function setEmbedLink(elink) {
  embedLink = elink;
  return getEmbedLink();
}

function getExport() {

  return getExport.prototype = {
    autoplayExport: function autoplayExport(element) {
      defaultVarEmbedLink.autoplay = element.checked ? 1 : 0;
      generateEmbedLink();
    },

    langueExport: function langueExport(lang) {
      console.log(lang);
    },

    timeExport: function timeExport(number, time) {
      var val = +number.value;
      if (time === 1) {
        defaultVarEmbedLink.start = Math.floor(defaultVarEmbedLink.start / 60) * 60 + val;
      } else {
        defaultVarEmbedLink.start = defaultVarEmbedLink.start % 60 + val * 60;
      }
      generateEmbedLink();
    },

    timeValidate: function timeValidate(number, time) {
      var val = number.value;
      if (time === 60) {
        if (!/^\d{1,3}$/.test(val)) {
          number.value = 0;
        }
      } else if (!/^[0-5]?[0-9]?$/.test(val)) {
        number.value = 0;
      }
    },

    colorExport: function colorExport(color) {
      var hex = color.value.substr(1).toUpperCase();
      defaultVarEmbedLink.color = hex;
      var colorText = document.getElementById("colorText");
      colorText.value = hex;
      generateEmbedLink();
    },
    selectAll: function selectAll(element) {
      element.focus();
      element.select();
    }
  };
}

window.getExport = getExport;

var ExportModalContent = function () {
    function ExportModalContent(player, options) {
        classCallCheck(this, ExportModalContent);

        this.player = player;

        this.options = options;

        this.copyBtnTextClass = 'vjs-export__btn-text';
        this.picker = "picker";

        this.urlLink = setEmbedLink(options.url);
        this.iframeLink = '<iframe width="560" height="315" src="' + this.urlLink + '" frameborder="0"  allowfullscreen></iframe>';
        this._createContent();
        this._initClipboard();

        // document.addEventListener("change", function(e){
        //     if (e.target && e.target.id === "time-selector" && changeInput) {
        //         changeInput = false;
        //         var selector = document.getElementById("time-selector");
        //         var duration = Math.floor(player.duration());
        //         var hour = Math.floor(duration / 3600);
        //         var minute = Math.floor((duration - hour * 3600) / 60);
        //         var seconde = Math.floor(duration - hour * 3600 - minute * 60);
        //         selector.max = hour + ":" + minute + ":" + seconde;
        //     }
        //
        // });
    }

    ExportModalContent.prototype.getContent = function getContent() {
        return this.content;
    };

    ExportModalContent.prototype._createContent = function _createContent() {
        var copyBtn = '\n       <span class="' + this.copyBtnTextClass + '">\n      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 34.555 34.555" style="enable-background:new 0 0 34.555 34.555;" xml:space="preserve" width="15px" height="15px">\n<g>\n\t<g>\n\t\t<g>\n\t\t\t<path d="M24.065,34.555H5.489c-1.379,0-2.5-1.122-2.5-2.5V7.864c0-1.378,1.121-2.5,2.5-2.5h2.364c0.276,0,0.5,0.224,0.5,0.5     s-0.224,0.5-0.5,0.5H5.489c-0.827,0-1.5,0.673-1.5,1.5v24.19c0,0.827,0.673,1.5,1.5,1.5h18.576c0.827,0,1.5-0.673,1.5-1.5v-2.365     c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v2.365C26.565,33.433,25.444,34.555,24.065,34.555z" fill="#707070"></path>\n\t\t</g>\n\t</g>\n\t<g>\n\t\t<g>\n\t\t\t<path d="M29.065,29.19H10.489c-1.379,0-2.5-1.122-2.5-2.5V2.5c0-1.378,1.121-2.5,2.5-2.5h13.604c0.276,0,0.5,0.224,0.5,0.5     S24.37,1,24.094,1H10.489c-0.827,0-1.5,0.673-1.5,1.5v24.19c0,0.827,0.673,1.5,1.5,1.5h18.576c0.827,0,1.5-0.673,1.5-1.5V7.661     c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5V26.69C31.565,28.069,30.444,29.19,29.065,29.19z" fill="#707070"></path>\n\t\t\t<path d="M31.065,8.161h-6.972c-0.276,0-0.5-0.224-0.5-0.5V0.688c0-0.276,0.224-0.5,0.5-0.5s0.5,0.224,0.5,0.5v6.473h6.472     c0.276,0,0.5,0.224,0.5,0.5S31.342,8.161,31.065,8.161z" fill="#707070"></path>\n\t\t\t<path d="M31.065,8.161c-0.13,0-0.26-0.051-0.358-0.151l-6.972-7.161c-0.192-0.198-0.188-0.514,0.01-0.707     c0.197-0.191,0.516-0.187,0.707,0.01l6.972,7.161c0.192,0.198,0.188,0.514-0.01,0.707C31.317,8.114,31.191,8.161,31.065,8.161z" fill="#707070"></path>\n\t\t</g>\n\t</g>\n</g>\n</svg>\n </span>\n    ';
        var wrapper = document.createElement('div');

        wrapper.innerHTML = '<div class="vjs-export">\n    <div class="vjs-export__top hidden-xs">\n        <div class="vjs-export__title">Le lien embed de la vid\xE9o</div>\n    </div>\n    <div class="vjs-export__middle">\n          <div class="vjs-export__short-link-wrapper">\n          <div class="vjs-export__btn vjs-export__is_copy">\n          ' + copyBtn + '\n        </div>\n            <input class="vjs-export__short-link vjs-export__is_copy vjs-export__copy" type="text" readonly="true"\n             value="' + this.options.embedCode + '">\n    </div>\n        <div class="vjs-export__row">\n        <div class="vjs-export__content">\n          <div class="vjs-export__subtitle hidden-xs">D\xE9marrer la lecture automatiquement</div>\n          <div class="toggle-switch-container">\n            <label class="switch">\n              <input type="checkbox" onchange="getExport().autoplayExport(this)">\n              <span class="slider round"></span>\n            </label>\n          </div>\n            \n        </div>\n        </div>\n        <div class="vjs-export__row">\n          <div class="vjs-export__content">\n              <div class="vjs-export__subtitle hidden-xs">Couleur par d\xE9faut de player</div>\n              <div class="color-wrapper">\n                <![if !IE]>\n                <input type="color" name="clr1" value="" onchange="getExport().colorExport(this)"/>\n                <![endif]>\n                <input id="colorText" class="vjs-export__textarea-color" value="#FFFFFF" type="text" readonly="true"/>\n              </div>\n          </div>\n          <!--[if IE]>\n              <input type="text" name="clr1" value="" style="display:none"/>\n              <button onclick="var s = Dlg.ChooseColorDlg(clr1.value); window.event.srcElement.style.color = s; clr1.value = s">&#9608;&#9608;&#9608;&#9608;&#9608;</button>\n              <object id="Dlg" classid="CLSID:3050F819-98B5-11CF-BB82-00AA00BDCE0B" width="0" height="0"></object>\n          <![endif]-->\n          </div>\n        <div>\n\n        <div class="vjs-export__row">\n            <div class="vjs-export__start">\n                <div class="vjs-export__subtitle hidden-xs">D\xE9marrer la lecture \xE0\n            </div>\n            <input class="vjs-export__time masked" type="text"  placeholder=\'00\' onkeyup="getExport().timeValidate(this, 60)"\n            onblur="getExport().timeExport(this, 60)">\n            <b>m</b>\n            <input class="vjs-export__time masked" type="text"  placeholder=\'00\' onkeyup="getExport().timeValidate(this, 1)"\n            onblur="getExport().timeExport(this, 1)">\n            <b>s</b>\n          </div>\n        </div>\n\n        <div class="vjs-export__subtitle hidden-xs">Int\xE9gration</div>\n        <div class="vjs-export__short-link-wrapper hidden-xs">\n        <textarea id="ifram_int" class="vjs-export__textarea-short-link" type="text" readonly="true" onclick="getExport().selectAll(this);" onfocus="getExport().selectAll(this);">' + this.iframeLink + '</textarea>\n  </div>\n    </div>\n</div>';

        this.content = wrapper.firstChild;
        document.addEventListener('click', function (e) {
            if (e.target && e.target.id === "autoplay_export_oui") {
                document.getElementById("autoplay_export_oui").className += " active";
                document.getElementById("autoplay_export_non").className = "vjs-export__input";
            } else if (e.target && e.target.id === "autoplay_export_non") {
                document.getElementById("autoplay_export_non").className += " active";
                document.getElementById("autoplay_export_oui").className = "vjs-export__input";
            }
        });
    };

    ExportModalContent.prototype._initClipboard = function _initClipboard() {
        var _this = this;

        var clipboard = new Clipboard('.vjs-export__btn', {
            target: function target(trigger) {
                return trigger.nextElementSibling;
            }
        });

        clipboard.on('success', function (e) {
            var textContainer = e.trigger.querySelector('.' + _this.copyBtnTextClass);
            var restore = function restore() {
                e.trigger.nextElementSibling.classList.remove("vjs-export__copied");
                e.trigger.nextElementSibling.classList.add("vjs-export__copy");
                e.clearSelection();
            };
            e.trigger.nextElementSibling.classList.remove("vjs-export__copy");
            e.trigger.nextElementSibling.classList.add("vjs-export__copied");
            // textContainer.innerText = this.player.localize('Copied');
            if (isTouchDevice()) {
                setTimeout(restore, 1000);
            } else {
                textContainer.addEventListener('mouseleave', function () {
                    setTimeout(restore, 300);
                });
            }
        });
    };

    return ExportModalContent;
}();

var Component = videojs.getComponent('Component');
/**
 * Export overlay.
 */

var ExportOverlay = function (_Component) {
  inherits(ExportOverlay, _Component);

  function ExportOverlay(player, options) {
    classCallCheck(this, ExportOverlay);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.player = player;
    _this.options = options;
    _this._createContent();
    return _this;
  }

  ExportOverlay.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-export-overlay'
    });
  };

  ExportOverlay.prototype._createContent = function _createContent() {
    var content = new ExportModalContent(this.player, this.options).getContent();
    videojs.dom.emptyEl(this.el());
    videojs.dom.appendContent(this.el(), content);
    if (!this.hasClass('vjs-export-overlay')) {
      this.addClass('vjs-export-overlay');
    }
    /*jQuery(document).ready(function() {
      jQuery('map').imageMapResize();
      var resizeObserver = new ResizeObserver(function(){
        var hexagon = document.getElementById("selectedhexagon");
        hexagon.style.visibility = "hidden";
         }).observe(document.getElementById("colormap"));
    });*/
  };

  return ExportOverlay;
}(Component);

var Component$1 = videojs.getComponent('Component');

var ExportShare = function (_Component) {
  inherits(ExportShare, _Component);

  function ExportShare(player, options) {
    classCallCheck(this, ExportShare);

    var _this = possibleConstructorReturn(this, _Component.call(this, player, options));

    _this.options = options;
    _this.addChild('ExportOverlay', _this.options);
    return _this;
  }

  ExportShare.prototype.createEl = function createEl() {
    return videojs.dom.createEl('div', {
      className: 'vjs-export-share'
    });
  };

  return ExportShare;
}(Component$1);

// Default options for the plugin.
// Cross-compatibility for Video.js 5 and 6.
var registerPlugin = videojs.registerPlugin || videojs.plugin;
// const dom = videojs.dom || videojs;

/**
 * Function to invoke when the player is ready.
 *
 * This is a great place for your plugin to initialize itself. When this
 * function is called, the player will have its DOM and child components
 * in place.
 *
 * @function onPlayerReady
 * @param    {Player} player
 *           A Video.js player object.
 *
 * @param    {Object} [options={}]
 *           A plain object containing options for the plugin.
 */
var onPlayerReady = function onPlayerReady(player, options) {
  player.addClass('vjs-videojs-export');
  //player.addChild('ExportShare', options);
};

/**
 * A video.js plugin.
 *
 * In the plugin function, the value of `this` is a video.js `Player`
 * instance. You cannot rely on the player being in a "ready" state here,
 * depending on how the plugin is invoked. This may or may not be important
 * to you; if not, remove the wait for "ready"!
 *
 * @function exportShare
 * @param    {Object} [options={}]
 *           An object of options left to the plugin author to define.
 */
var exportShare = function exportShare(options) {
  onPlayerReady(this, videojs.mergeOptions(defaults, options));
};

videojs.registerComponent('ExportShare', ExportShare);
videojs.registerComponent('ExportButton', ExportButton);
videojs.registerComponent('ExportOverlay', ExportOverlay);

// Register the plugin with video.js.
registerPlugin('exportShare', exportShare);

// Include the version number.
exportShare.VERSION = version;

module.exports = exportShare;



//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_exportShare/dist/videojs-export-share.cjs.js
// module id = 709
// module chunks = 0